import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import { IA_POLITICS } from 'edelvives/config/config';
import React from 'react';

const AIPolitics = () => {
  return (
    <div>
      <PdfViewerFullScreen url={IA_POLITICS.es} />
    </div>
  );
};

export default AIPolitics;
